/* eslint-disable */

export default class ScaffoldSampleValidator {

  constructor(sample, config) {
    this.config = config;
    this.sample = sample;
  }

  validate() {
    if (!Properties.existsOnSample(this.sample) && !Entities.existsOnSample(this.sample)) {
      Utils.error('File has no properties or entities');
    }

    Properties.validate(this.sample, this.config);
    Entities.validate(this.sample, this.config);
  }
}

class Entities {
  static validate(sample, config) {
    if (!Entities.existsOnConfig(config)) {
      return;
    }

    if (!Entities.existsOnSample(sample)) {
      Utils.error('entities is empty');
    }

    Entities.validateNameAndLabel(sample, config);
    if (Utils.isObject(config.entities) && config.entities.fields) {
      sample.entities.forEach(entity => {
        Fields.validate(sample.entities, entity, config);
        EntityProperties.validate(entity, config);
      });
    }
  }

  static existsOnConfig(config) {
    if (config.entities) {
      return true;
    }else {
      return false;
    }
  }

  static existsOnSample(sample) {
    return sample.entities && sample.entities.length > 0;
  }

  static validateNameAndLabel(sample, config) {
    sample.entities.forEach((entity, i) => {
      if (!entity.name || !entity.name.singular) {
        Utils.error(`entities[${i}] has no singular name`);
      }
      if (Utils.isObject(config.entities) && config.entities.name_plural) {
        if (!entity.name.plural) {
          Utils.error(`entities[${i}] has no plural name`);
        }
      }
      if (Utils.isObject(config.entities) && config.entities.label) {
        if (!entity.label || !entity.label.singular) {
          Utils.error(`entities[${i}] has no singular label`);
        }
      }
      if (Utils.isObject(config.entities) && config.entities.label_plural) {
        if (!entity.label.plural) {
          Utils.error(`entities[${i}] has no plural label`);
        }
      }
    });
  }
}

class EntityProperties {
  static validate(entity, config) {
    if (!EntityProperties.existsOnConfig(config)) {
      return;
    }
    EntityProperties.validateAllPropertiesExistsInConfig(entity, config);
    EntityProperties.validateAllPropertiesRequiredExists(entity, config);
    EntityProperties.validateAllPropertiesValuesAreCompatible(entity, config);
  }

  static existsOnEntity(entity) {
    return entity.properties && Object.keys(entity.properties).length > 0;
  }
  static existsOnConfig(config) {
    return config.entities.properties && Object.keys(config.entities.properties).length > 0;
  }

  static validateAllPropertiesExistsInConfig(entity, config) {
    if (!EntityProperties.existsOnEntity(entity)) {
      return;
    }
    if (!config.entities.properties) {
      Utils.error('config has no entities.properties defined');
    }
    Object.keys(entity.properties).forEach((property_key) => {
      if (!config.entities.properties[property_key]) {
        Utils.error(`${entity.name.singular}.properties.${property_key} is not defined in config`);
      }
    });
  }

  static validateAllPropertiesRequiredExists(entity, config) {
    Object.keys(config.entities.properties).forEach((key) => {
      if (config.entities.properties[key].required) {
        if (!EntityProperties.existsOnEntity(entity) || (!entity.properties[key] && entity.properties[key] !== false)) {
          Utils.error(`${entity.name.singular}.properties.${key} is required`);
        }
      }
    });
  }

  static validateAllPropertiesValuesAreCompatible(entity, config) {
    if (!EntityProperties.existsOnEntity(entity)) {
      return;
    }
    Object.keys(entity.properties).forEach((property_key) => {
      let value = entity.properties[property_key];

      if (!value) {
        return;
      }

      let input = config.entities.properties[property_key].input;
      let choices = config.entities.properties[property_key].choices;
      let fields = entity.fields;
      if (!input || input === 'text') {
        return;
      }

      if (input === 'number') {
        if (isNaN(value)) {
          Utils.error(`${entity.name.singular}.properties.${property_key} is not a valid number`);
        }
      }

      if (input === 'select') {
        if (!Object.keys(choices).some((key) => key === value)) {
            Utils.error(`${entity.name.singular}.properties.${property_key} value is not one of the property's choices`);
        }
      }

      if (input === 'field') {
        if (!value) {
          return;
        }

        if (!fields || fields.length <= 0) {
            Utils.error(`${entity.name.singular}.properties.${property_key} is a field, but entity has no fields`);
        }
        if (!fields.some((field) => field.id === value)) {
            Utils.error(`${entity.name.singular}.properties.${property_key} value is not one of the entity's fields`);
        }
      }

      if (input === 'field_to_display') {
        if (!value) {
          return;
        }

        if (value === 'id') {
          return;
        }

        if (fields && fields.length && !fields.some((field) => field.id === value)) {
            Utils.error(`${entity.name.singular}.properties.${property_key} value is not one of the entity's fields`);
        }
      }

    });
  }
}

class Fields {
  static validate(entities, entity, config) {
    if (!Fields.existsOnConfig(config)) {
      return;
    }
    if (!Fields.existsOnEntity(entity)) {
      Utils.error(`${entity.name.singular}.fields is empty`);
    }

    Fields.validateNameAndLabel(entity, config);
    entity.fields.forEach(f => {
      FieldType.validate(entities, entity, f, config);
    });
  }

  static existsOnConfig(config) {
    if (config.entities.fields) {
      return true;
    }else {
      return false;
    }
  }

  static existsOnEntity(entity) {
    return entity.fields && entity.fields.length > 0;
  }

  static validateNameAndLabel(entity, config) {
    entity.fields.forEach((field, i) => {
      if (!field.name || !field.name.singular) {
        Utils.error(`${entity.name.singular}.fields[${i}] has no singular name`);
      }
      if (config.entities.fields.name_plural) {
        if (!field.name.plural) {
          Utils.error(`${entity.name.singular}.fields[${i}] has no plural name`);
        }
      }
      if (config.entities.fields.label) {
        if (!field.label || !field.label.singular) {
          Utils.error(`${entity.name.singular}.fields[${i}] has no singular label`);
        }
      }
      if (config.entities.fields.label_plural) {
        if (!field.label.plural) {
          Utils.error(`${entity.name.singular}.fields[${i}] has no plural label`);
        }
      }
    });
  }
}

class FieldType {
  static validate(entities, entity, field, config) {
    if (!FieldType.existsOnConfig(config)) {
      return;
    }
    if (!FieldType.existsOnField(field)) {
      Utils.error(`${entity.name.singular}.${field.name.singular}.type is empty`);
    }
    if (!FieldType.valueExistsOnConfig(field, config)) {
      Utils.error(`${entity.name.singular}.${field.name.singular}.type[${field.type}] does not exists in config`);
    }
    FieldProperties.validate(entity, field, config);
    FieldValidations.validate(entity, field, config);
    FieldRelationProperties.validate(entities, entity, field, config);
  }

  static existsOnField(field) {
    if (field.type) {
      return true;
    }else {
      return false;
    }
  }

  static existsOnConfig(config) {
    if (config.entities.fields.types && Object.keys(config.entities.fields.types).length > 0) {
      return true;
    }else {
      return false;
    }
  }

  static valueExistsOnConfig(field, config) {
    return Object.keys(config.entities.fields.types).some((key) => {
      return field.type === key;
    });
  }
}

class FieldRelationProperties {
  static validate(entities, entity, field, config) {
    if (!FieldRelationProperties.existsOnConfig(field, config)) {
      return;
    }
    FieldRelationProperties.validateAllPropertiesExistsInConfig(entity, field, config);
    FieldRelationProperties.validateAllPropertiesRequiredExists(entity, field, config);
    FieldRelationProperties.validateAllPropertiesValuesAreCompatible(entities, entity, field, config);
  }

  static existsOnSample(field) {
    return field.relation;
  }

  static isArrayOnSample(field) {
    return field.relation && Object.keys(field.relation).length > 0;
  }

  static existsOnConfig(field, config) {
    return config.entities.fields.types[field.type].relation;
  }

  static isArrayOnConfig(field, config) {
    return config.entities.fields.types[field.type].relation && config.entities.fields.types[field.type].relation.length > 0;
  }

  static validateAllPropertiesExistsInConfig(entity, field, config) {
    if (!FieldRelationProperties.existsOnSample(field)) {
      return;
    }

    if (!FieldRelationProperties.isArrayOnSample(field)) {
      return;
    }

    Object.keys(field.relation).forEach((property_key) => {
      if (property_key !== 'entity') {
        if (!config.entities.fields['relation-properties'][property_key]) {
          Utils.error(`${entity.name.singular}.${field.name.singular}.relation.${property_key} is not defined in config`);
        }
      }
    });
  }

  static validateAllPropertiesRequiredExists(entity, field, config) {
    if (!FieldRelationProperties.existsOnSample(field)) {
      return;
    }

    if(!field.relation['entity']){
      Utils.error(`${entity.name.singular}.${field.name.singular}.relation.entity is required`);
    }

    config.entities.fields.types[field.type].relation.forEach((key) => {
      if (config.entities.fields['relation-properties'][key].required) {
        if (!FieldRelationProperties.existsOnSample(field) || (!field.relation[key] && field.relation[key] !== false)) {
          Utils.error(`${entity.name.singular}.${field.name.singular}.relation.${key} is required`);
        }
      }
    });
  }

  static validateAllPropertiesValuesAreCompatible(entities, entity, field, config) {
    if (!FieldRelationProperties.existsOnSample(field)) {
      return;
    }

    Object.keys(field.relation).forEach((property_key) => {
      if (property_key === 'entity') {
        return;
      }

      let value = field.relation[property_key];
      let input = config.entities.fields['relation-properties'][property_key].input;
      let choices = config.entities.fields['relation-properties'][property_key].choices;
      let relationEntity = entities.find((m) => m.id === field.relation['entity']);
      if(!relationEntity){
        Utils.error(`${entity.name.singular}.${field.name.singular}.relation.entity is not an existing entity`);
      }
      let fields = relationEntity.fields;

      if (!input || input === 'text') {
        return;
      }

      if (input === 'number') {
        if (isNaN(value)) {
          Utils.error(`${entity.name.singular}.${field.name.singular}.relation.${property_key} is not a valid number`);
        }
      }

      if (input === 'select') {
        if (!Object.keys(choices).some((key) => key === value)) {
            Utils.error(`${entity.name.singular}.${field.name.singular}.relation.${property_key} value is not one of the property's choices`);
        }
      }

      if (input === 'field') {
        if (!value) {
          return;
        }

        if (!fields || fields.length <= 0) {
            Utils.error(`${entity.name.singular}.${field.name.singular}.relation.${property_key} is a field, but related entity has no fields`);
        }
        if (!fields.some((field) => field.id === value)) {
            Utils.error(`${entity.name.singular}.${field.name.singular}.relation.${property_key} value is not one of the related entity's fields`);
        }
      }

      if (input === 'field_to_display') {
        if (!value) {
          return;
        }

        if (value === 'id') {
          return;
        }

        if (fields && fields.length && !fields.some((field) => field.id === value)) {
            Utils.error(`${entity.name.singular}.${field.name.singular}.relation.${property_key} value is not one of the related entity's fields`);
        }
      }

    });
  }
}

class FieldProperties {
    static validate(entity, field, config) {
    if (!FieldProperties.existsOnConfig(field, config)) {
      return;
    }
    FieldProperties.validateAllPropertiesExistsInConfig(entity, field, config);
    FieldProperties.validateAllPropertiesRequiredExists(entity, field, config);
    FieldProperties.validateAllPropertiesValuesAreCompatible(entity, field, config);
  }

  static existsOnSample(field) {
    return field.properties && Object.keys(field.properties).length > 0;
  }
  static existsOnConfig(field, config) {
    return config.entities.fields.types[field.type].properties && config.entities.fields.types[field.type].properties.length > 0;
  }

  static validateAllPropertiesExistsInConfig(entity, field, config) {
    if (!FieldProperties.existsOnSample(field)) {
      return;
    }
    Object.keys(field.properties).forEach((property_key) => {
      if (!config.entities.fields.properties[property_key]) {
        Utils.error(`${entity.name.singular}.${field.name.singular}.properties.${property_key} is not defined in config`);
      }
    });
  }

  static validateAllPropertiesRequiredExists(entity, field, config) {
    config.entities.fields.types[field.type].properties.forEach((key) => {
      if (config.entities.fields.properties[key].required) {
        if (!FieldProperties.existsOnSample(field) || (!field.properties[key] && field.properties[key] !== false)) {
          Utils.error(`${entity.name.singular}.${field.name.singular}.properties.${key} is required`);
        }
      }
    });
  }

  static validateAllPropertiesValuesAreCompatible(entity, field, config) {
    if (!FieldProperties.existsOnSample(field)) {
      return;
    }
    Object.keys(field.properties).forEach((property_key) => {
      let value = field.properties[property_key];
      let input = config.entities.fields.properties[property_key].input;
      let choices = config.entities.fields.properties[property_key].choices;
      if (!input || input === 'text') {
        return;
      }

      if (input === 'number') {
        if (isNaN(value)) {
          Utils.error(`${entity.name.singular}.${field.name.singular}.properties.${property_key} is not a valid number`);
        }
      }

      if (input === 'select') {
        if (!Object.keys(choices).some((key) => key === value)) {
            Utils.error(`${entity.name.singular}.${field.name.singular}.properties.${property_key} value is not one of the property's choices`);
        }
      }
    });
  }
}

class FieldValidations {
    static validate(entity, field, config) {
    if (!FieldValidations.existsOnConfig(field, config)) {
      return;
    }
    FieldValidations.validateAllValidationsExistsInConfig(entity, field, config);
    FieldValidations.validateAllValidationsRequiredExists(entity, field, config);
    FieldValidations.validateAllValidationsValuesAreCompatible(entity, field, config);
  }

  static existsOnSample(field) {
    return field.validations && field.validations.length > 0;
  }
  static existsOnConfig(field, config) {
    return config.entities.fields.types[field.type].validations && config.entities.fields.types[field.type].validations.length > 0;
  }

  static validateAllValidationsExistsInConfig(entity, field, config) {
    if (!FieldValidations.existsOnSample(field)) {
      return;
    }
    field.validations.forEach((validation) => {
      if (!config.entities.fields.validations[validation.key]) {
        Utils.error(`${entity.name.singular}.${field.name.singular}.validations.${validation.key} is not defined in config`);
      }
    });
  }

  static validateAllValidationsRequiredExists(entity, field, config) {
    config.entities.fields.types[field.type].validations.forEach((key) => {
      if (config.entities.fields.validations[key].required) {
        let validation = field.validations.find(v => v.key === key);
        if (!FieldValidations.existsOnSample(field) || (!validation || (!validation.value &&  validation.value !== false))) {
          Utils.error(`${entity.name.singular}.${field.name.singular}.validations.${key} is required`);
        }
      }
    });
  }

  static validateAllValidationsValuesAreCompatible(entity, field, config) {
    if (!FieldValidations.existsOnSample(field)) {
      return;
    }
    field.validations.forEach((validation) => {
      let value = validation.value;
      let input = config.entities.fields.validations[validation.key].input;
      let choices = config.entities.fields.validations[validation.key].choices;
      if (!input || input === 'text') {
        return;
      }

      if (input === 'number') {
        if (isNaN(value)) {
          Utils.error(`${entity.name.singular}.${field.name.singular}.validations.${validation_key} is not a valid number`);
        }
      }

      if (input === 'select') {
        if (!Object.keys(choices).some((key) => key === value)) {
            Utils.error(`${entity.name.singular}.${field.name.singular}.validations.${validation_key} value is not one of the validation's choices`);
        }
      }
    });
  }
}

class Properties {
  static validate(sample, config) {
    if (!Properties.existsOnConfig(config)) {
      return;
    }
    Properties.validateAllPropertiesExistsInConfig(sample, config);
    Properties.validateAllPropertiesRequiredExists(sample, config);
    Properties.validateAllPropertiesValuesAreCompatible(sample, config);
  }

  static existsOnSample(sample) {
    return sample.properties && Object.keys(sample.properties).length > 0;
  }
  static existsOnConfig(config) {
    return config.properties && Object.keys(config.properties).length > 0;
  }

  static validateAllPropertiesExistsInConfig(sample, config) {
    if (!Properties.existsOnSample(sample)) {
      return;
    }
    if (!config.properties) {
      Utils.error('config has no properties defined');
    }
    Object.keys(sample.properties).forEach((property_key) => {
      if (!config.properties[property_key]) {
        Utils.error(`properties.${property_key} is not defined in config`);
      }
    });
  }

  static validateAllPropertiesRequiredExists(sample, config) {
    Object.keys(config.properties).forEach((key) => {
      if (config.properties[key].required) {
        if (!Properties.existsOnSample(sample) || (!sample.properties[key] && sample.properties[key] !== false)) {
          Utils.error(`properties.${key} is required`);
        }
      }
    });
  }

  static validateAllPropertiesValuesAreCompatible(sample, config) {
    if (!Properties.existsOnSample(sample)) {
      return;
    }
    Object.keys(sample.properties).forEach((property_key) => {
      let value = sample.properties[property_key];
      let input = config.properties[property_key].input;
      let choices = config.properties[property_key].choices;
      let entities = sample.entities;

      if (!input || input === 'text') {
        return;
      }

      if (input === 'number') {
        if (isNaN(value)) {
          Utils.error(`properties.${property_key} is not a valid number`);
        }
      }

      if (input === 'select') {
        if (!Object.keys(choices).some((key) => key === value)) {
            Utils.error(`properties.${property_key} value is not one of the property's choices`);
        }
      }

      if (input === 'entity') {
        if (!entities || entities.length <= 0) {
            Utils.error(`properties.${property_key} is an entity, but entities is not defined`);
        }
        if (!entities.some((entity) => entity.id === value)) {
            Utils.error(`properties.${property_key} value is not an entity`);
        }
      }
    });
  }
}

class Utils {
  static validatePropertyIncludeInKeys(object, validKeys, parentsPath) {
    Object.keys(object).forEach((key) => {
      if (!validKeys.includes(key)) {
        Utils.errorInvalidProperty(`${parentsPath ? parentsPath :''}${key}`, validKeys);
      }
    });
  }

  static allArrayHasKeyinObject(array, obj) {
    if (!array) {
      return true;
    }
    if (!obj) {
      return false;
    }
    if (!Array.isArray(array)) {
      return false;
    }
    return array.every((inArray) => {
      return Object.keys(obj).some((key) => inArray === key);
    });
  }

  static error(message) {
    throw new Error(`Error on scaffoldhub/sample.json: ${message}`);
  }

  static errorInvalidValue(value, valids) {
    Utils.error(`Invalid value for '${value}'. Valid values are '${valids.join("','")}'`);
  }
  static errorInvalidProperty(property, valids) {
    Utils.error(`Invalid '${property}'. Valid properties are '${valids.join("','")}'`);
  }

  static isObject(val) {
    return val instanceof Object;
  }
}
